import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown, Smartphone, Zap, Shield, TrendingUp } from 'lucide-react';

const Hero = () => {
  const handleJoinWaitlist = () => {
    document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToNext = () => {
    document.getElementById('problem').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="min-h-screen flex items-center hero-gradient pt-20">
      <div className="container-max">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="space-y-8"
          >
            <div className="space-y-6">
              <h1 className="text-5xl lg:text-7xl font-bold text-gray-900 leading-tight">
                <span className="text-gradient">Revolutionary</span>
                <br />
                Dental Health
                <br />
                <span className="text-gradient">Detection</span>
              </h1>
              
              <h2 className="text-xl lg:text-2xl font-medium text-gray-600 leading-relaxed">
                Advanced AI-powered dental disease detection using 405nm UV imaging technology. 
                Get instant, accurate results from your smartphone.
              </h2>
            </div>
            
            <p className="text-lg text-gray-600 leading-relaxed">
              Oralytics combines cutting-edge UV imaging with clinically validated AI models 
              to detect plaque, gingivitis, and calculus in real-time. Trusted by dental 
              professionals worldwide.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={handleJoinWaitlist}
                className="btn-primary flex items-center justify-center space-x-3 text-lg px-8 py-4 shadow-xl hover:shadow-2xl transition-all duration-300"
              >
                <Smartphone className="w-6 h-6" />
                <span>Join Waitlist</span>
              </button>
              <button 
                onClick={scrollToNext}
                className="btn-secondary flex items-center justify-center space-x-3 text-lg px-8 py-4"
              >
                <span>See How It Works</span>
                <ArrowDown className="w-5 h-5" />
              </button>
            </div>

            {/* Trust indicators */}
            <div className="flex items-center space-x-8 text-sm text-gray-600 pt-4">
              <div className="flex items-center space-x-2">
                <Zap className="w-5 h-5 text-oralytics-500" />
                <span className="font-medium">Instant Results</span>
              </div>
              <div className="flex items-center space-x-2">
                <Shield className="w-5 h-5 text-oralytics-500" />
                <span className="font-medium">Clinically Validated</span>
              </div>
              <div className="flex items-center space-x-2">
                <TrendingUp className="w-5 h-5 text-oralytics-500" />
                <span className="font-medium">95% Accuracy</span>
              </div>
            </div>
          </motion.div>

          {/* Right Content - Enhanced Phone Mockup */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative"
          >
            <div className="relative">
              {/* Hero Image */}
              <img 
                src="/images/hero/hero-intraoral-diagram.png" 
                alt="Oralytics Intraoral Device Technology" 
                className="w-full h-auto rounded-2xl shadow-2xl"
              />

              {/* Floating Elements */}
              <motion.div
                animate={{ y: [-10, 10, -10] }}
                transition={{ duration: 3, repeat: Infinity }}
                className="absolute -top-4 -right-4 w-12 h-12 bg-gradient-to-br from-oralytics-400 to-oralytics-600 rounded-full opacity-80 shadow-lg"
              />
              <motion.div
                animate={{ y: [10, -10, 10] }}
                transition={{ duration: 4, repeat: Infinity }}
                className="absolute -bottom-4 -left-4 w-8 h-8 bg-gradient-to-br from-green-400 to-green-600 rounded-full opacity-80 shadow-lg"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 